import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import api from '@/lib/api';
import { toast } from 'sonner';

// /cookout/join?code=XXXX&from=@handle
// • Logged in  → auto-redeem → /home?tab=cookout
// • Not logged in → save code → / (landing handles post-login redeem)
export default function CookoutJoinPage() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | redeeming | done | error

  useEffect(() => {
    if (authLoading) return;

    const code = searchParams.get('code');

    if (!code) {
      // No code — just go to cookout tab
      navigate('/home?tab=cookout', { replace: true });
      return;
    }

    if (!user) {
      // Save code so AuthCallbackHandler can redeem after login
      localStorage.setItem('blvx-pending-invite', code.toUpperCase());
      navigate('/', { replace: true });
      return;
    }

    // Logged in — auto-redeem, zero friction
    setStatus('redeeming');
    api.post(`/vouch/plate/redeem?code=${encodeURIComponent(code.toUpperCase())}`)
      .then(() => {
        setStatus('done');
        toast.success('Plate accepted. Pull up to The Cookout.');
        navigate('/home?tab=cookout', { replace: true });
      })
      .catch((error) => {
        const detail = error?.response?.data?.detail;
        toast.error(typeof detail === 'string' ? detail : 'That Plate code could not be redeemed.');
        // Code may already be redeemed or invalid — still send them to Cookout
        navigate('/home?tab=cookout', { replace: true });
      });
  }, [authLoading, user, searchParams, navigate]);

  // Fullscreen fire splash while processing
  return (
    <div style={{
      minHeight: '100dvh',
      background: '#050608',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
    }}>
      {/* Logo */}
      <div style={{
        fontFamily: "'Bebas Neue', sans-serif",
        fontSize: '38px',
        letterSpacing: '4px',
        color: '#EAE0CC',
      }}>
        BL<span style={{ color: '#F07B1D' }}>VX</span>
      </div>

      {/* Fire spinner */}
      <div style={{
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        border: '2px solid rgba(240,123,29,0.2)',
        borderTopColor: '#F07B1D',
        animation: 'spin 0.8s linear infinite',
      }} />

      <p style={{
        fontFamily: "'Azeret Mono', monospace",
        fontSize: '11px',
        letterSpacing: '3px',
        color: '#72788A',
        textTransform: 'uppercase',
      }}>
        {status === 'redeeming' ? 'Joining The Cookout...' : 'Entering The Culture...'}
      </p>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
